<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle toCapitalize">{{ locale.mobility_destination_preset_setting }}</h2>
      <div class="mb30">
        <div class="presetSetting">
          <button type="button" class="btn btnWhite" @click="addItem">{{ locale.mobility_destination_preset_add }}</button>
        </div>
        <div v-if="list && list.length" class="mobilityPreset">
          <draggable
            v-model="list"
            v-bind="{
              animation: 200,
              group: 'description',
              disabled: false,
              ghostClass: 'ghost'
            }"
            tag="div"
            class="presetList">
            <transition-group
              type="transition"
              tag="div"
              class="presetItemBox">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="presetItem">
              <div class="name"><span>{{ item.name }}</span></div>
              <div class="presetItemInner">
                <div v-if="item.img" class="img"><img :src="item.img" alt=""></div>
                <div class="title">{{ item.title[defaultLang] }}</div>
                <div v-if="item.description[defaultLang]" class="description">{{ item.description[defaultLang] }}</div>
              </div>
              <button type="button" class="btn btnEdit toCapitalize" @click.stop="editItem(item)">{{ locale.modify }}</button>
              <button type="button" class="btnDel" @click.stop="delItem(item)"></button>
            </div>
            </transition-group>
          </draggable>
        </div>
        <div v-else class="noData">{{ locale.mobility_destination_preset_nodata }}</div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnFull btnPrimary toCapitalize" @click.stop="apply">{{ locale.apply }}</button>
      </div>
    </div>
    <MobilityPresetItem
      v-if="presetLayer"
      :locale="locale"
      :presetData="presetData"
      @apply="applyItem"
      @cancel="cancelItem" />
  </div>
</template>

<script>
import UTIL from '@/common/util'
import MobilityPresetItem from './MobilityPresetItem.vue'
import UNIQUE from '@/common/unique'
import draggable from 'vuedraggable'

export default {
  name: 'EditMobility',
  props: [
    'locale',
    'presetList'
  ],
  components: {
    MobilityPresetItem,
    draggable
  },
  computed: {
    defaultLang () {
      const lang = this.$store.getters['setting/getData'].lang
      return lang.default
    },
    langValue () {
      const langValue = this.$store.getters['setting/getData'].lang.langValue
      return this._.cloneDeep(langValue)
    }
  },
  created () {
    this.list = _.cloneDeep(this.presetList)
  },
  data () {
    return {
      presetLayer: false,
      presetData: null,
      list: []
    }
  },
  methods: {
    addItem () {
      const langValue = this.langValue
      const item = {
        id: UNIQUE.mid(),
        name: '',
        title: UTIL.fillLangs(langValue, ''),
        description: UTIL.fillLangs(langValue, ''),
        img: ''
      }
      this.presetData = item
      this.setPreset(true)
    },
    editItem (item) {
      this.presetData = item
      this.setPreset(true)
    },
    delItem (item) {
      if (window.confirm(this.locale.confirm_delete_place)) {
        this.list = this.list.filter(x => x.id !== item.id)
      }
    },
    onClone (data) {
      const cloneData = this._.cloneDeep(data)
      // cloneData.id = UNIQUE.mid()
      return cloneData
    },
    setPreset (isOpen) {
      this.presetLayer = isOpen
      if (!isOpen) {
        this.presetData = null
      }
    },
    editPreset (isOpen) {
      this.editLayer = isOpen
    },
    applyItem (item) {
      const isExist = this.list.find(x => x.id === item.id)
      if (isExist) {
        this.list = this.list.map(x => {
          return x.id === item.id ? item : x
        })
      } else {
        this.list = [item].concat(this.list)
      }
      this.setPreset(false)
    },
    cancelItem () {
      this.setPreset(false)
    },
    apply () {
      if (window.confirm(this.locale.confirm_apply_preset_setting)) {
        this.$emit('apply', this.list)
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel_preset_setting)) {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 840px;
}
.presetList {
  margin-top: 15px;
}
.presetItemInner {
  margin-bottom: 8px;
}
.presetItem {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 15px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
  background-color: $color-white;
  cursor: move;
  &:hover {
    border-color: $color-primary;
  }
  .presetItemInner {
    flex: 1;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    background: url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
    opacity: 0.5;
  }
  .btnEdit {
    border-radius: 4px;
  }
  .name {
    margin-bottom: 8px;
    span {
      display: inline-block;
      padding: 4px 15px;
      border-radius: 30px;
      border: 1px solid $color-lgrey2;
    }
  }
}
.noData{
  padding-top: 60px;
  padding-bottom: 90px;
  text-align: center;
  font-size: 20px;
  color: $color-lgrey;
}
.btns {
  width: 240px;
  margin: 0 auto;
}
</style>
